export default __webpack_public_path__ + "static/media/571.96f590d0.gif";